import { Section } from 'src/app/components/Elements/Section';

import { OtcCarousel } from '../styles';

import { OTCItem } from './OTCItem';

export const CarouselSection = ({ otcItems, promoCode }) => {
  if (!otcItems) {
    return null;
  }

  return (
    <Section data-cy="otc-carousel">
      {promoCode === 'sakara' ? <img src="/public/sakara_logo_thick_black 2.png" style={{ height: '30px' }} /> : null}
      <h3>
        {promoCode === 'sakara'
          ? 'Get Sakara supplements and essentials delivered to your door today. For free.'
          : 'Choose a free product to try Capsule risk-free.'}
      </h3>
      <OtcCarousel className="row flex-row flex-nowrap mt-4 pb-4" style={{ overflowX: 'auto' }}>
        {otcItems.map(item => (
          <OTCItem
            altText={item.title}
            imgUrl={item.src}
            name={item.title}
            price={item.price}
            strength={item.strength}
            markedPrice={item.markedPrice}
          />
        ))}
      </OtcCarousel>
    </Section>
  );
};
